export default __webpack_public_path__ + "static/media/Increase.fcf5a0d4.svg";